import { useState } from 'react'

import { TableDataQa } from 'commons/types/enums'
import { SidePanel } from 'ui/components'
import { Table } from 'ui/components/Table'
import { useCrbMonitorListContext } from '~bank-crb-monitor/list/context'

import { CRBIdLicensePanel } from '../CRBIdLicensePanel'
import { CRBPanel } from '../CRBPanel'
import { columns } from './columns'
import { HistoryDialog } from './components'

export const CRBTable = () => {
  const { routeApi, data, isLoading } = useCrbMonitorListContext()
  const navigate = routeApi.useNavigate()
  const {
    connections,
    form: { page, size, sortDesc, sortBy },
    totalCount
  } = data

  const [historyId, setHistoryId] = useState(0)
  const [panelState, setPanelState] = useState<{
    open: boolean
    licenseId: number
    mode: 'view' | 'edit'
    crbId: number
  }>({ open: false, licenseId: 0, mode: 'edit', crbId: 0 })

  const onLicenseSelect = (view: 'view' | 'edit', licenseId: number, crbId: number) => {
    if (!panelState.open) {
      setPanelState({ open: true, licenseId, mode: view, crbId })
    } else {
      setTimeout(() => setPanelState({ open: true, licenseId, mode: view, crbId }), 250)
    }
  }

  return (
    <>
      {historyId > 0 && <HistoryDialog id={historyId} onClose={() => setHistoryId(0)} />}

      {panelState.mode === 'view' ? (
        <SidePanel
          isOpened={panelState.open}
          content={
            <CRBIdLicensePanel
              crbId={panelState.crbId}
              onEdit={() => setPanelState((prev) => ({ ...prev, mode: 'edit' }))}
            />
          }
          referenceNode={document.querySelector(`div[data-sidepanel="${panelState.licenseId}"]`) ?? undefined}
          onOpenClose={(open) => setPanelState((prev) => ({ ...prev, open }))}
        />
      ) : (
        <SidePanel
          isOpened={panelState.open}
          content={<CRBPanel licenseId={panelState.licenseId} />}
          referenceNode={document.querySelector(`div[data-sidepanel="${panelState.licenseId}"]`) ?? undefined}
          onOpenClose={(open) => setPanelState((prev) => ({ ...prev, open }))}
        />
      )}

      <Table
        dataQa={TableDataQa.CRB_MONITOR_LIST}
        columns={columns({ onOpenHistory: setHistoryId, onLicenseSelect })}
        dataSource={connections?.map((item) => ({ item }))}
        pagination={{
          page,
          size,
          total: totalCount,
          onChange: (page: number, size: number) => {
            navigate({ to: '.', search: (prev) => ({ ...prev, page, size }) })
          }
        }}
        sorting={{
          order: [{ field: sortBy, direction: sortDesc ? 'DESC' : 'ASC' }],
          onChange: ({ field, direction }) => {
            navigate({ to: '.', search: (prev) => ({ ...prev, sortBy: field, sortDesc: direction === 'DESC' }) })
          }
        }}
        loading={isLoading}
      />
    </>
  )
}
